import { render, staticRenderFns } from "./WaveProgress.vue?vue&type=template&id=24682abe&scoped=true&"
import script from "./WaveProgress.vue?vue&type=script&lang=js&"
export * from "./WaveProgress.vue?vue&type=script&lang=js&"
import style0 from "./WaveProgress.vue?vue&type=style&index=0&id=24682abe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24682abe",
  null
  
)

export default component.exports